import { useQuery } from '@tanstack/react-query';

import { fetchOCClaimDetails } from '../data-provider/claim-details';

export const useGetOCClaimDetails = (fbOcKey: number | undefined) => {
  return useQuery({
    enabled: Boolean(fbOcKey),
    queryFn: () => fetchOCClaimDetails({ FBOCKey: Number(fbOcKey) }),
    queryKey: ['claims-over-charge-details', fbOcKey],
  });
};
